import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ReportWizardPanel } from "src/app/constants/wizard-panels";
import { DetailFileType, ReportWizardDetail, ReportWizardDetailPayload } from "src/app/models/reports";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-report-builder-detail',
    templateUrl: './report-builder-detail.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportBuilderDetailComponent implements OnInit {
    @Input() public reportWizardDetail: ReportWizardDetail;

    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitSave: EventEmitter<ReportWizardDetailPayload> = new EventEmitter<ReportWizardDetailPayload>();

    public detailForm: FormGroup;
    public caption: string;

    public displayTemplate: boolean;
    public reportWizardPanel = ReportWizardPanel;
    public fileTypes: DetailFileType[];

    public fileTypeCheckboxSelect: string = 'selected';
    public fileExportType: string = 'fileExportType';

    public fileTypeFormArrayName: string = 'fileTypeFormArrayName';
    public dateWizardValue: string = 'dateWizardValue';

    constructor(
        private formBuilder: FormBuilder,
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        this.caption = this.reportWizardDetail.fileName;
        this.displayTemplate = this.reportWizardDetail.saveAsTemplate;
        this.fileTypes = this.reportWizardDetail.fileTypes;

        this.detailForm = this.formBuilder.group({
            fileName: [this.reportWizardDetail.fileName],
            saveAsTemplate: [this.reportWizardDetail.saveAsTemplate],
            templateName: [this.reportWizardDetail.fileName],
            templateDescription: [this.reportWizardDetail.templateDescription],
            fileType: [null, Validators.required],
            sendEmailOnFinish: [false],
        });
    }

    private formatFileName(text: string): string {
        return text.replace(/[ ]/g, '_');
    }

    public selectionChange(event: MatCheckboxChange): void {
        this.displayTemplate = event.checked;
    }

    public cancel(): void {
        this.emitCancel.emit();
    }

    public save(): void {
        let l_ScheduledEventPayload = this.helperService.convertFormGroupIntoObject(this.detailForm, new ReportWizardDetailPayload());
        this.emitSave.emit(l_ScheduledEventPayload);
    }

}
